import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import Sidebar from '../../components/Sidebar';
import '../Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://metro4.dcairo.com/api';

const ViewBreakingResults = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [resultsData, setResultsData] = useState([]);
  
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    fetchResults();
  }, [currentMonth, currentYear]);

  const fetchResults = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      
      const response = await axios.get(
        `${API_URL}/pours/breaking-results-calendar?year=${currentYear}&month=${currentMonth + 1}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        setResultsData(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching results:', error);
      if (error.response?.status === 401) {
        toast.error('انتهت الجلسة');
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  };

  const monthNames = [
    'يناير', 'فبراير', 'مارس', 'إبريل', 'مايو', 'يونيو',
    'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
  ];

  const getDaysInMonth = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const handlePrevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  };

  const handleNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const getResultsForDate = (day) => {
    const dateStr = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    return resultsData.find(r => r.date === dateStr);
  };

  const handleDateClick = (day) => {
    const result = getResultsForDate(day);
    if (result && result.count > 0) {
      // Navigate to results detail page (سنعملها لاحقاً)
      console.log('Show results for:', result);
      toast.success(`${result.count} ورقة في هذا اليوم`);
    }
  };

  const daysInMonth = getDaysInMonth(currentMonth, currentYear);
  const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <button className="menu-toggle" onClick={toggleSidebar}>
            ☰
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
            <button 
              onClick={() => navigate('/cubes/results')}
              style={{
                background: 'linear-gradient(135deg, #64748b 0%, #475569 100%)',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '10px',
                cursor: 'pointer',
                fontSize: '15px',
                fontWeight: '700',
                transition: 'all 0.3s',
                boxShadow: '0 4px 12px rgba(100, 116, 139, 0.3)'
              }}
            >
              ← رجوع
            </button>
            <h1 style={{ margin: 0 }}>📅 عرض نتائج التكسير</h1>
          </div>
        </div>

        <div className="dashboard-main">
          <style>{`
            .calendar-container {
              max-width: 1200px;
              margin: 0 auto;
              padding: 20px;
            }

            .calendar-header {
              background: white;
              padding: 20px;
              border-radius: 12px;
              margin-bottom: 20px;
              box-shadow: 0 2px 10px rgba(0,0,0,0.1);
              display: flex;
              justify-content: space-between;
              align-items: center;
            }

            .month-title {
              font-size: 24px;
              font-weight: 800;
              color: #1e293b;
            }

            .month-nav {
              display: flex;
              gap: 10px;
            }

            .nav-btn {
              background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
              color: white;
              border: none;
              padding: 10px 20px;
              border-radius: 8px;
              font-size: 14px;
              font-weight: 700;
              cursor: pointer;
              transition: all 0.3s;
            }

            .nav-btn:hover {
              transform: translateY(-2px);
              box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
            }

            .calendar-grid {
              display: grid;
              grid-template-columns: repeat(7, 1fr);
              gap: 15px;
            }

            .day-card {
              background: white;
              border-radius: 12px;
              padding: 15px;
              text-align: center;
              box-shadow: 0 2px 8px rgba(0,0,0,0.08);
              transition: all 0.3s;
              cursor: pointer;
              border: 2px solid transparent;
              min-height: 80px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            }

            .day-card:hover {
              transform: translateY(-4px);
              box-shadow: 0 6px 20px rgba(0,0,0,0.15);
            }

            .day-card.has-results {
              border-color: #16a34a;
              background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
            }

            .day-card.has-results:hover {
              border-color: #22c55e;
            }

            .day-number {
              font-size: 20px;
              font-weight: 800;
              color: #1e293b;
              margin-bottom: 8px;
            }

            .day-card.has-results .day-number {
              color: #16a34a;
            }

            .results-count {
              font-size: 14px;
              font-weight: 700;
              color: #16a34a;
              background: white;
              padding: 4px 12px;
              border-radius: 12px;
              border: 2px solid #16a34a;
            }

            .empty-state {
              text-align: center;
              padding: 60px 20px;
              color: #94a3b8;
            }

            .loading-state {
              text-align: center;
              padding: 40px 20px;
            }

            @media (max-width: 768px) {
              .calendar-grid {
                grid-template-columns: repeat(4, 1fr);
                gap: 10px;
              }

              .day-card {
                padding: 10px;
                min-height: 60px;
              }

              .day-number {
                font-size: 16px;
              }

              .results-count {
                font-size: 12px;
                padding: 2px 8px;
              }

              .calendar-header {
                flex-direction: column;
                gap: 15px;
              }

              .month-title {
                font-size: 20px;
              }
            }

            @media (max-width: 480px) {
              .calendar-grid {
                grid-template-columns: repeat(3, 1fr);
              }
            }
          `}</style>

          <div className="calendar-container">
            <div className="calendar-header">
              <h2 className="month-title">
                {monthNames[currentMonth]} {currentYear}
              </h2>
              <div className="month-nav">
                <button className="nav-btn" onClick={handlePrevMonth}>
                  ← السابق
                </button>
                <button className="nav-btn" onClick={handleNextMonth}>
                  التالي →
                </button>
              </div>
            </div>

            {loading ? (
              <div className="loading-state">
                <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏳</div>
                <p>جاري التحميل...</p>
              </div>
            ) : (
              <div className="calendar-grid">
                {days.map(day => {
                  const result = getResultsForDate(day);
                  const hasResults = result && result.count > 0;

                  return (
                    <div
                      key={day}
                      className={`day-card ${hasResults ? 'has-results' : ''}`}
                      onClick={() => handleDateClick(day)}
                    >
                      <div className="day-number">{day}</div>
                      {hasResults && (
                        <div className="results-count">
                          {result.count}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}

            {!loading && resultsData.length === 0 && (
              <div className="empty-state">
                <div style={{ fontSize: '60px', marginBottom: '20px' }}>📭</div>
                <h3 style={{ fontSize: '20px', color: '#64748b' }}>لا توجد نتائج في هذا الشهر</h3>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBreakingResults;
